import { render, staticRenderFns } from "./Article4.vue?vue&type=template&id=6dcb1a18&"
import script from "./Article4.vue?vue&type=script&lang=js&"
export * from "./Article4.vue?vue&type=script&lang=js&"
import style0 from "./Article4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports